import { useNavigate } from "react-router-dom"
import { LogOut } from "lucide-react"
import { supabase } from "@/integrations/supabase/client"
import {
  SidebarFooter as Footer,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import { useToast } from "@/hooks/use-toast"

export function SidebarFooter() {
  const navigate = useNavigate()
  const { toast } = useToast()

  const handleLogout = async () => {
    const { error } = await supabase.auth.signOut()
    if (error) {
      toast({
        variant: "destructive",
        title: "Erro ao sair",
        description: "Por favor tente novamente.",
      })
      return
    }
    toast({
      title: "Sucesso",
      description: "Usuário deslogado com sucesso.",
    })
    navigate("/login")
  }

  return (
    <Footer>
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton 
            onClick={handleLogout}
            className="text-red-600 hover:bg-red-50 hover:text-red-700"
          >
            <LogOut size={20} />
            <span>Sair</span>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </Footer>
  )
}